import { Component, OnInit } from '@angular/core';
import { TotemService } from '../totem.service';
import * as moment from 'moment';
@Component({
  selector: 'app-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.css']
})
export class EventosComponent implements OnInit {
  listaeventos = [];
  constructor(  private totemService: TotemService) { }

  async ngOnInit() {
    const eventoslist = await this.totemService.geteventos().subscribe(eventos => {
      for (const even of eventos) {

        if (even.tipo_evento === 'Evento' && even.publicado === 1) {

          if (moment().isBetween(even.dia_inicio, even.dia_termino)) {
            even.horaini = even.hora_inicio.substr(0, 5);
            even.horafin = even.hora_termino.substr(0, 5);
            this.listaeventos.push(even);
          }
        }
      }

    });
  }
  // logica de reinicio
  scrollevent = (event: any): void => {
    console.log('scroll');
    this.cancelartimer();
  }
  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }
}
